import { withState } from './BonusWallets.state';
import { BonusWallets as BonusWalletsDefault } from './BonusWallets';

export const BonusWallets = withState(BonusWalletsDefault);
